// Een doorklik naar een ander tabblad vanuit een paneel dat geen navigatie
// aangereikt krijgt (W5, funding werkend).
//
// SkillDetail wordt op vier plekken gerenderd (Skills, de feed, de chat, de
// observatie) en krijgt nergens een navigatiefunctie mee. In plaats van die
// vier aanroepers te verbouwen stuurt het paneel één venster-gebeurtenis met
// een gewone `Landing` (contract api/redactie.schema.json); App.tsx luistert
// en behandelt hem als elke andere landing (openLanding). Zonder luisteraar
// gebeurt er niets — geen fout, en in een test geen netwerk.

import type { KaartLanding } from "../contracts";

export const NAAR_TAB = "sof:naar-tab";

export function naarTab(landing: KaartLanding): void {
  window.dispatchEvent(new CustomEvent<KaartLanding>(NAAR_TAB, { detail: landing }));
}
